<div class="login-container">
    <!--left-->
    <div class="left-container">
        <div class="left-content">
            <img src="assets/logo.svg" alt="Logo" [routerLink]="['/login']" style="max-width: 250px; filter: brightness(0) invert(1);"/>
        </div>
    </div>
    <!--right-->
    <div class="right-container">
        <div class="welldone-card card rounder-5">
            <div class="card-content">
                <div class="card-body">
                    <h1 class="card-title text-dark text-center">Conferma OTP</h1>
                    <span class="step-subtitle">Per procedere e confermare l'attivazione dell'account inserisci il codice OTP che ti abbiamo inviato via email.</span>
                    <form #confirmotp="ngForm" >
                        <div class="email-input">
                            <input #emailInput
                                   required
                                   name="otp"
                                   type="text"
                                   class="form-control"
                                   id="otp"
                                   aria-describedby="otp"
                                   placeholder="OTP"
                                   style="margin-top: 10px"
                                   [(ngModel)]="otp"
                            >
                        </div>
                        <div class="d-flex flex-column">
                            <button type="submit" class="btn btn-primary" (click)="confirmOtp()" [disabled]="confirmotp.invalid">Conferma</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>
